module.exports = __webpack_public_path__ + "static/media/loading.7c655f0f.gif";